import { provideTransloco, TranslocoModule } from '@ngneat/transloco';
import { Injectable, isDevMode, NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-http-loader';
import { TRADUZIONI_CONSENTITE } from '@app-lib';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: TRADUZIONI_CONSENTITE,
        reRenderOnLangChange: true,
        fallbackLang: ['en', 'it'],
        defaultLang: 'it',
        // Remove this option if your application doesn't support changing language in runtime.
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
